export type SaveMessages = 'save' | 'saved' | 'saving';

export const SaveProfileErrors = {
  None: 0,
  BioTooLong: 1,
  UsernameInvalid: 2,
  UsernameIsReserved: 3,
  UsernameTaken: 4,
  UsernameTooLong: 5,
  UsernameTooShort: 6,
  Unknown: 7,
} as const;
export type SaveProfileError =
  (typeof SaveProfileErrors)[keyof typeof SaveProfileErrors];

export const saveProfileErrorMapping: { [key: string]: SaveProfileError } = {
  'username is taken': SaveProfileErrors.UsernameTaken,
  'username must be at least 3 characters': SaveProfileErrors.UsernameTooShort,
  'username must be at most 100 characters': SaveProfileErrors.UsernameTooLong,
  'username is invalid: only lowercase letters, underscores, and numbers are allowed':
    SaveProfileErrors.UsernameInvalid,
  'username is reserved': SaveProfileErrors.UsernameIsReserved,
  'invalid value for bio': SaveProfileErrors.BioTooLong,
};
